var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed inset-0 z-10 object-cover",attrs:{"id":"bg"}},[_c('transition',{attrs:{"name":"fadeVideo"}},[_c('img',{staticClass:"w-full h-full",attrs:{"src":_vm.imgSrc,"alt":""}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }